class QuickAdd extends HTMLElement {
    static forms = {};
    constructor() {
        super();
    }
    connectedCallback() {
        this.handle = this.dataset.handle;
        this.query = "?section_id=product--quick-add--form&variant=" + this.dataset.id;

        this.on("click keydown", async (t) => {
            if (t.type === "keydown" && t.key !== "Enter") return;
            t.preventDefault();
            this.setAttribute("data-loading", !0);
            await this.showForm();
            this.setAttribute("data-loading", !1);
            
            //Update price total quick view 
            let cartTotalEl = document.querySelector(".b2b-cstm-cart-drawer .saw-cart-total");
            let originalTotalEl = document.querySelector(".saw-cart-original-total .cart--total--price");

            let cartTotal = cartTotalEl ? cartTotalEl.innerText.trim() : "";
            let originalTotal = originalTotalEl ? originalTotalEl.innerText.trim() : "";

            // Loop through all quick-view-drawer-total elements
            document.querySelectorAll(".quick-view-drawer-total").forEach(el => {
                if (cartTotal && cartTotal !== "$0.00") {
                    el.innerHTML = cartTotal;
                    console.log("Updated with cartTotal → " + cartTotal);
                } else if (originalTotal) {
                    el.innerHTML = originalTotal;
                    console.log("Updated with originalTotal → " + originalTotal);
                }
            });       


        });
    }

    async showForm() {
        let shouldLoadForm = true;
        Object.keys(QuickAdd.forms).forEach((key) => {
            QuickAdd.forms[key].style.display = key === this.handle ? "block" : "none";
            if (key === this.handle) shouldLoadForm = false;
        });

        if (shouldLoadForm) {
            try {
                const response = await fetch(`${theme.urls.root}/products/${this.handle}/` + this.query);
                if (!response.ok) {
                    this.setAttribute("data-loading", !1);
                    throw new Error(response.status);
                }
                const htmlText = await response.text();
                const formElement = theme.utils.parseHtml(htmlText, ".product--quick-add--form");
                QuickAdd.forms[this.handle] = formElement;
                theme.drawer.querySelector('[data-view="product-form"]').appendChild(formElement);
            } catch (err) {
                console.error("Failed to load form:", err);
            }
        }

        theme.utils.updateRecentProducts(this.handle);
        theme.drawer.open("right", "product-form", this);
    }

    async addToCart() {
        if (theme.utils.getQuantity(this.dataset.id, this.dataset, 1)) {
            try {
                await theme.cart.addItem(this.dataset.id, 1);
                theme.drawer.open("right", "cart-drawer", this);
            } catch (t) {
                this.setAttribute("data-loading", !1);
                throw new Error(t);
            }
        }
    }

    static clearFormListeners() {
        window.on("theme:navigation:reloaded theme:search:reloaded", () => {
            Object.keys(QuickAdd.forms).forEach((key) => QuickAdd.forms[key].remove());
            QuickAdd.forms = {};
        });
    }
}

QuickAdd.clearFormListeners();
customElements.define("product-quick-add", QuickAdd);
